// extracted by mini-css-extract-plugin
export var carrierNotice = "_ja-5";
export var carrierNoticePlaceholder = "_ja-6";
export var deliveryRow = "_ja-c";
export var fixedHeight = "_ja-4";
export var freightLogo = "_ja-b";
export var fullWidth = "_ja-3";
export var priceColumn = "_ja-7";
export var radioSelected = "_ja-9";
export var radioUnselected = "_ja-8";
export var selectedOption = "_ja-2";
export var selectedOptionContainer = "_ja-1";
export var selection = "_ja-0";
export var tallSkeletonText = "_ja-a";